module.exports = __webpack_public_path__ + "img/logo-bottom.5775fa2.svg";